import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { Box, Fab, Typography } from '@mui/material';
import GridItem from '@jumbo/components/GridItem';
import { HOST, UPLOAD_MAX_IMAGE_SIZE } from 'config/config';
import { DropzoneArea } from 'react-mui-dropzone';
import {
  useDeleteExteriorSignageQuoteLogo,
  useUpdateExteriorSignageQuoteLogo,
} from 'services/Data/ExteriorSignageQuoteService';
import { Delete } from '@mui/icons-material';
import { BlobStorageTypeEnumValue } from 'enums/BlobStorageTypeEnum';

const useStyles = makeStyles(theme => ({
  borderDanger: {
    borderColor: theme.palette.danger.main,
  },
}));

const ExteriorSignageQuoteUploadLogoSection = ({ exteriorSignageQuote, isLoading, validator, isDisabled }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { mutate: updateExteriorSignageQuoteLogo } = useUpdateExteriorSignageQuoteLogo();
  const { mutate: deleteExteriorSignageQuoteLogo } = useDeleteExteriorSignageQuoteLogo();

  const handleDropFileArea = files => {
    if (files.length > 0) {
      updateExteriorSignageQuoteLogo({ exteriorSignageQuoteId: exteriorSignageQuote.id, files: [files[0]] });
    }
  };

  const handleDeletePhoto = attachedFileId => {
    deleteExteriorSignageQuoteLogo({ exteriorSignageQuoteId: exteriorSignageQuote.id, photoId: attachedFileId });
  };

  return (
    <Box>
      <GridItem xs={12} style={{ marginTop: '2rem' }}>
        <Typography variant="h1" sx={{ my: 2 }}>
          {t('upload_logo')}
        </Typography>
        <Typography variant="h5" sx={{ my: 2, fontWeight: 'bold' }}>
          {t('logo_file_format')}
        </Typography>
        {!isDisabled && (
          <DropzoneArea
            // classes={{
            //   root: validator.current.message(
            //     t('exteriorSignageQuoteFiles'),
            //     exteriorSignageQuote?.files?.length,
            //     `greater_than_or_equal:1`,
            //   )
            //     ? classes.borderDanger
            //     : '',
            // }}
            maxFileSize={UPLOAD_MAX_IMAGE_SIZE}
            filesLimit={1}
            showPreviewsInDropzone={false}
            showAlerts={false}
            onChange={files => {
              handleDropFileArea(files);
            }}
            Icon={() => <></>}
            dropzoneText={t('drag_and_drop_logo')}
            dropzoneClass={classes.dropzone}
          />
        )}
      </GridItem>
      <GridItem xs={12} style={{ marginTop: '1rem' }}>
        {exteriorSignageQuote?.files?.length > 0 && (
          <>
            {!isDisabled && (
              <Fab color="error" onClick={() => handleDeletePhoto(exteriorSignageQuote?.files[0].id)}>
                <Delete />
              </Fab>
            )}

            <img
              src={`${HOST}/api/dashboard/attached-files/${exteriorSignageQuote.id}/${exteriorSignageQuote?.files[0].id}/download?type=${BlobStorageTypeEnumValue.ExteriorSignageQuote}`}
              alt={t('exterior_signage_dealer_logo')}
              style={{ maxHeight: '60vh', width: '100%', objectFit: 'contain' }}
            />
          </>
        )}
      </GridItem>
    </Box>
  );
};

export default ExteriorSignageQuoteUploadLogoSection;
